import api from "../../axiosConfig";

export const addPharmacist = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/pharmacies/add', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getPharmacist = async () => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/pharmacies/all', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching pharmacies');
  }
};

export const updatePharmacist = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`pharmacies/update/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update pharmacist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating pharmacies');
  }
};